<template>
  <div style="padding-bottom: 6px">
    <!-- 名称和指数数字 -->
    <span style="margin-right: 4px; font-size: 14px">{{ name }}</span>
    <span style="font-size: 11px">{{ val }}</span>
    <span style="font-size: 10px; color: #999">/100</span>

    <!-- 色带 -->
    <div class="index-wrapper">
      <div class="index-content" :style="`width:${width}px`"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['val', 'name'],
  computed: {
    width() {
      return +(this.val / 10).toFixed(0) * 10
    },
  },
}
</script>
<style scoped>
.index-wrapper {
  height: 5px;
  width: 160px;
  background-image: url('./item-index-bg.png');
  background-repeat: no-repeat;
}
.index-content {
  float: left;
  height: 100%;
  background-image: url('./item-index.png');
}
</style>


// WEBPACK FOOTER //
// src/components/disease/list/item-index.vue